import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccordionModule } from 'primeng/accordion';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'gig-dynamic-info-list',
  standalone: true,
  imports: [CommonModule, AccordionModule, TooltipModule, TranslateModule],
  templateUrl: './dynamic-info-list.component.html',
  styleUrls: ['./dynamic-info-list.component.scss']
})
export class DynamicInfoListComponent implements OnInit, OnChanges {

  public items: any;

  @Input() title: string;
  @Input() cols: any[];
  @Input() data: any;
  @Input() toolTipPath: string;
  @Input() tipLocation: string = 'right';
  @Input() colors: any;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data && changes.data.currentValue) {
      this.parseListDetails();
    }

  }
  
  ngOnInit(): void {
   
  }

  private parseListDetails(): void {
    this.items = [];

    const dataKeys = Object.keys(this.data);
    //const referringLinksAttributes = this.data.referringLinksAttributes;

    dataKeys.forEach(key => {
      const value = !this.data[key] ? 0 : this.data[key];
      this.items.push({
        name: key,
        value
      });
    });

  }

}
